(function () {
  const selectors = {
    modal: '[data-world-cup-gift-modal]',
    trigger: '[data-world-cup-gift-trigger]',
    close: '[data-world-cup-gift-close]',
    copy: '[data-world-cup-gift-copy]',
    mobilePromo: '.menu-drawer-v2__promo'
  };

  const mobilePromoImageSeenKey = 'frostixWorldCupGiftPromoImageSeen';
  const mobilePromoImageHiddenClass = 'menu-drawer-v2__promo--image-hidden';
  const mobilePromoImageSeenRootClass = 'world-cup-gift-promo-image-seen';

  function getSessionFlag(key) {
    try {
      return window.sessionStorage?.getItem(key) === 'true';
    } catch (error) {
      return false;
    }
  }

  function setSessionFlag(key) {
    try {
      window.sessionStorage?.setItem(key, 'true');
    } catch (error) {
      // Storage can be blocked in private/browser-restricted contexts.
      // The class toggle below still hides the image for the current page view.
    }
  }

  function hideMobilePromoImages() {
    document.documentElement.classList.add(mobilePromoImageSeenRootClass);
    document
      .querySelectorAll(selectors.mobilePromo)
      .forEach((promo) => promo.classList.add(mobilePromoImageHiddenClass));
  }

  function initWorldCupGiftPromo() {
    const modal = document.querySelector(selectors.modal);
    if (!modal) return;

    const dialog = modal.querySelector('.world-cup-gift-modal__dialog');
    const triggers = document.querySelectorAll(selectors.trigger);
    const closeButtons = modal.querySelectorAll(selectors.close);
    const copyButtons = modal.querySelectorAll(selectors.copy);
    let lastFocusedElement = null;
    let shouldHideMobileImageOnClose = false;

    if (getSessionFlag(mobilePromoImageSeenKey)) {
      hideMobilePromoImages();
    }

    function openModal(event) {
      if (event) event.preventDefault();
      lastFocusedElement = document.activeElement;
      shouldHideMobileImageOnClose = true;
      modal.hidden = false;
      document.documentElement.classList.add('world-cup-gift-modal-open');
      window.setTimeout(() => dialog?.focus(), 0);
    }

    function closeModal() {
      modal.hidden = true;
      document.documentElement.classList.remove('world-cup-gift-modal-open');
      if (shouldHideMobileImageOnClose) {
        setSessionFlag(mobilePromoImageSeenKey);
        hideMobilePromoImages();
        shouldHideMobileImageOnClose = false;
      }
      if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
        lastFocusedElement.focus();
      }
    }

    async function copyCode(button) {
      const code = button.dataset.worldCupGiftCopy;
      if (!code) return;

      try {
        if (navigator.clipboard?.writeText) {
          await navigator.clipboard.writeText(code);
        } else {
          const input = document.createElement('textarea');
          input.value = code;
          input.setAttribute('readonly', '');
          input.style.position = 'fixed';
          input.style.opacity = '0';
          document.body.appendChild(input);
          input.select();
          document.execCommand('copy');
          document.body.removeChild(input);
        }
        button.classList.add('is-copied');
        window.setTimeout(() => button.classList.remove('is-copied'), 1400);
      } catch (error) {
        button.classList.add('is-copy-error');
        window.setTimeout(() => button.classList.remove('is-copy-error'), 1400);
      }
    }

    triggers.forEach((trigger) => trigger.addEventListener('click', openModal));
    closeButtons.forEach((button) => button.addEventListener('click', closeModal));
    copyButtons.forEach((button) => button.addEventListener('click', () => copyCode(button)));

    document.addEventListener('keydown', (event) => {
      if (modal.hidden || event.key !== 'Escape') return;
      closeModal();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWorldCupGiftPromo);
  } else {
    initWorldCupGiftPromo();
  }
})();
